import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Link as MineralLink } from "mineral-ui";

const Link = props =>
  props.to ? (
    <MineralLink element={RouterLink} {...props} />
  ) : (
    <MineralLink {...props} />
  );

export const ExternalLink = ({ children, ...props }) => (
  <MineralLink {...props}>
    {children} <span className="fas fa-external-link-alt" />
  </MineralLink>
);

export default Link;
